import * as angular from "angular";
import {IController} from "angular";

export class PlanningDraftTotalsBarCtrl implements IController {

  draftInfo: any;
  draftStatistics: any;
  isTotalsBarOpen: any;
  onToggleDraft: Function;

  private currencyUnit: any;

  constructor(private splitService) {
    this.currencyUnit = this.splitService.getCurrencySymbol();
  }

  $onInit() {
  }

}

angular
  .module('bringoz.admin.planning')
  .component('planningDraftTotalsBar', {
    bindings: {
      draftInfo: '<',
      draftStatistics: '<',
      isTotalsBarOpen: '<',
      onToggleDraft: '&'
    },
    template: require('./planning-draft-totals-bar.html').default,
    controller: PlanningDraftTotalsBarCtrl
  });

